export default "__VITE_ASSET__BGpjQi$V__"